import { GanttActionTargetType, GanttActionType } from '@pages/ConfiduredGantt/types'

import { AutocompleteOption } from '@types'

import { isCellTarget, isSegmentTarget } from './helpers'

export const getActionsFormatted = (actions: GanttActionType[]) =>
  actions.map(action => {
    const formatTarget = (target: any) => {
      if (!target) return undefined

      if (Array.isArray(target)) {
        return target.map((t: AutocompleteOption) => t.id)
      }

      if (typeof target === 'object' && 'id' in target) {
        return target.id
      }

      return target
    }

    return {
      ...action,
      target: formatTarget(action.target),
    }
  })

export const getActionsForReset: (actions: GanttActionType[]) => GanttActionType[] = (
  actions: GanttActionType[]
) =>
  actions.map(action => {
    const getValueByType = (
      target: GanttActionTargetType,
      eventCode: string
    ): GanttActionTargetType => {
      if (!target) return undefined

      if (isSegmentTarget(eventCode)) {
        if (Array.isArray(target)) {
          return target.map(opt => ({ id: opt, label: opt }))
        }

        return [
          {
            id: target,
            label: target,
          },
        ]
      }

      if (isCellTarget(eventCode)) {
        if (Array.isArray(target) && target.length > 0) {
          return {
            id: target[0],
            label: target[0],
          }
        }

        return {
          id: target,
          label: target,
        }
      }

      return undefined
    }

    return {
      ...action,
      target: getValueByType(action.target, action.eventCode),
    }
  })
